"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const GlobalSearch_styles_1 = require("./GlobalSearch.styles");
const styles_1 = require("../styles");
const GlobalSearch = ({ searchLabel, searchBy, setSearchBy, tableId, isLoading = false }) => {
    const inputInfo = (typeof searchLabel === 'string' && searchLabel) || 'Search';
    const searchLabelId = `global-search-input-label-${tableId}-search`;
    const searchId = `global-search-input-${tableId}-search`;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(styles_1.HiddenFilterLabel, { id: searchLabelId, htmlFor: searchId }, inputInfo),
        react_1.default.createElement(GlobalSearch_styles_1.SearchInput, { "data-testid": "global-search", id: searchId, disabled: isLoading, name: searchId, "aria-labelledby": searchLabelId, value: searchBy || '', onChange: (e) => {
                if (setSearchBy) {
                    setSearchBy(e.target.value || undefined);
                }
            }, title: inputInfo, placeholder: inputInfo })));
};
exports.default = GlobalSearch;
//# sourceMappingURL=GlobalSearch.js.map